import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropdownOptions } from './shared-button.model';

@Component({
  selector: 'shared-button',
  templateUrl: './shared-button.component.html',
  styleUrls: ['./shared-button.component.scss']
})
export class SharedButtonComponent {

  @Input() variant: 'default' | 'stroke';
  @Input() mode: 'button' | 'dropdown'
  @Input() color: string;
  @Input() icon?: string;
  @Input() dropdownOptions?: DropdownOptions;
  @Output() click = new EventEmitter<boolean>();

  constructor() { }

  onClick() {
    this.click.emit(true);
  }

  onSelect(value: string) {
    this.dropdownOptions?.onSelect(value)
  }
}